module.exports = __webpack_public_path__ + "static/media/videoPeel-white-logo.87d7215a.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/videoPeel-white-logo.png
// module id = 2534
// module chunks = 33